























































import { Component, Vue, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import BackofficeCadastroMedicoStore from '@/components/Backoffice/Store/BackofficeCadastroMedicoStore'
import EventBus from '@/plugins/EventBus'

@Component

export default class ModalBackofficeCadastroMedicoAssociarCadastro extends Vue {
  get getBackofficeCadastroMedicoStore() {
    return getModule(BackofficeCadastroMedicoStore, this.$store)
  }

  get showModalBackofficeCadastroMedicoAssociarCadastro() { return this.getBackofficeCadastroMedicoStore.modal.cadastroMedicoAssociarCadastro }
  set showModalBackofficeCadastroMedicoAssociarCadastro(value: boolean) { this.getBackofficeCadastroMedicoStore.setModal({ name: 'cadastroMedicoAssociarCadastro', value }) }

  loadAssociarCadastro: boolean = false
  get loadingAssociarCadastro() { return this.loadAssociarCadastro }
  set loadingAssociarCadastro(value: boolean) { this.loadAssociarCadastro = value }

  async backofficeAssociaPreCadastroExistente() {
    this.loadingAssociarCadastro = true
    const response = await this.getBackofficeCadastroMedicoStore.backofficeAssociaPreCadastroExistente()
    if (!response.success) {
      EventBus.$emit('setSnackbar', { show: true, text: `${response.message || 'Ocorreu um erro ao associar a conta.'} ${String.fromCodePoint(0x1F615)}`, icon: 'warning', color: '#C62828' })
      this.loadingAssociarCadastro = false
      return
    }

    EventBus.$emit('setSnackbar', { show: true, text: `Associação de conta realizada com sucesso. ${String.fromCodePoint(0x1F642)}`, icon: 'done', color: '#2E7D32' })
    EventBus.$emit('resetFormCadastro')
    await this.getBackofficeCadastroMedicoStore.getAllCadastrosMedicosByUsuarioHospital(this.getBackofficeCadastroMedicoStore.paginationMedicosCadastrados)
    this.showModalBackofficeCadastroMedicoAssociarCadastro = false
    this.loadingAssociarCadastro = false
  }

  @Watch('showModalBackofficeCadastroMedicoAssociarCadastro')
  onChangeShowModalBackofficeCadastroMedicoAssociarCadastro(value: boolean) {
    if (!value) {
      this.getBackofficeCadastroMedicoStore.clearMedicoASerAssociado()
    }
  }
}
